/**
 * Internal Dependencies
 */
// Auth
import AuthSignIn from './AuthSignIn';
import AuthSignUp from './AuthSignUp';

// Start
import Dashboard from './Dashboard';
import Profile from "./Profile";

//Páginas
import CargosPage from "./Cargos";
import NovaVendaPage from "./NovaVenda";
import ColaboradoresPage from "./Colaboradores";
import MetasPage from "./Metas";
import ClientesPage from "./Clientes";
import EquipesPage from "./Equipes";
import PlanosPage from "./Planos";
import ProdutosPage from "./produto";
import DashboardSupervisao from "./DashboradSupervisao";
import LeadsPage from "./Leads";
import ShowVendaPage from "./NovaVenda/show";
import AcompanhamentoPage from "./Acompanhamento";
import PreVendaPage from "./PreVenda";
import DashboardMetas from "./DashboardMetas";
import MinhasNegociacoesPage from "./MinhasNegociacoes";
import DistribuicaoLeadsPage from "./Leads/distribuicao";
import MailingPage from "./mailing";
import UsuariosPage from "./Usuarios";
import ViabilidadePage from "./Viabilidade";
import ShowColaboradorEquipePage from "./Colaboradores/equipe";
import DashboardFinanceiro from "./DashboardFinanceiro";
import MeusLeadsPage from "./MeusLeads";
import CompartilhadosPage from "./Compartilhados";
import ComissionamentoPage from "./Financeiro/Comissionamento";
import CreditosPage from "./Financeiro/Creditos";
import DashboardOperador from "./DashboardOperador";
import ShowVendaBackofficePage from "./NovaVenda/backoffice";
import UpdateStatusVendasPage from "./UpdateStatusVendasPage";
import EditUsuariosPage from "./Usuarios/edit";
import EditProdutoPage from "./produto/edit";
import EditPlanosPage from "./Planos/edit";
import TrocarSenhaPage from "./TrocarSenha";
import EditEquipePage from "./Equipes/edit";
import AtualizacaoEnderecosPage from "./AtualizacaoEnderecos";
import AcionamentoPage from "./acionamento";
import EditAcionamentoPage from "./acionamento/edit";
import LeadsWifisulfibra from "./LeadsWifisulfibra";
import FiliaisPage from "./Filiais";
import EditFilialPage from "./Filiais/edit";
import EditConfiguracoesPage from "./Configuracoes/edit";
import ConfiguracoesPage from "./Configuracoes";
import BancosPage from "./Bancos";
import EditBancoPage from "./Bancos/edit";
import EditOperadoraPage from "./Operadoras/edit";
import OperadorasPage from "./Operadoras";

export default {
    '/sign-in': AuthSignIn,
    '/sign-up': AuthSignUp,

    '/': localStorage.getItem( 'account_type' ) === 1 ? Dashboard : ViabilidadePage,
    '/dash-supervisao': DashboardSupervisao,
    '/dash-metas': DashboardMetas,
    '/dash-financeiro': DashboardFinanceiro,
    '/dash-operador': DashboardOperador,
    '/dash-admin': Dashboard,
    '/profile': Profile,

    '/leads': LeadsPage,
    '/leads/wifisulfibra': LeadsWifisulfibra,
    '/leads/distribuicao': DistribuicaoLeadsPage,
    '/mailing': MailingPage,
    '/viabilidade': ViabilidadePage,

    // Forms Base
    '/cargo': CargosPage,
    '/equipe': EquipesPage,
    '/colaborador': ColaboradoresPage,
    '/meta': MetasPage,
    '/cliente': ClientesPage,
    '/plano': PlanosPage,
    '/nova-venda': NovaVendaPage,
    '/produto': ProdutosPage,
    '/acionamento': AcionamentoPage,
    '/minhas-negociacoes': MinhasNegociacoesPage,
    '/meus-leads': MeusLeadsPage,
    '/vendas-compartilhadas': CompartilhadosPage,
    '/usuarios': UsuariosPage,
    '/filiais': FiliaisPage,
    '/bancos': BancosPage,
    '/operadoras': OperadorasPage,
    '/configuracoes': ConfiguracoesPage,

    '/totais-comissoes': ComissionamentoPage,
    '/totais-venda': CreditosPage,

    '/back-office': AcompanhamentoPage,
    '/pre-venda': PreVendaPage,

    //show
    '/nova-venda/show/:id': ShowVendaPage,
    '/venda/back-office/show/:id': ShowVendaBackofficePage,
    '/colaborador/equipe/:idUser': ShowColaboradorEquipePage,

    //edits
    '/usuarios/edit/:id': EditUsuariosPage,
    '/produto/edit/:id': EditProdutoPage,
    '/plano/edit/:id': EditPlanosPage,
    '/equipe/edit/:id': EditEquipePage,
    '/filial/edit/:id': EditFilialPage,
    '/banco/edit/:id': EditBancoPage,
    '/operadora/edit/:id': EditOperadoraPage,
    '/configuracao/edit/:id': EditConfiguracoesPage,

    '/funcoes-administrativas': UpdateStatusVendasPage,
    '/trocar-senha': TrocarSenhaPage,

    //novos
    '/atualizacao-enderecos': AtualizacaoEnderecosPage,

    '/acionamento/edit/:id': EditAcionamentoPage,

};
